import React from 'react';
import Referral from './Referral';
import About from './About';
import Copyright from './Copyright';
import './footer.css';

const Footer = () => {
  return (
    <>
      <Referral></Referral>
      <About></About>
      <Copyright></Copyright>
    </>
  );
};

export default Footer;
